/** spacing styles names */
export const SPACING_NAMES = {
  COMFORTABLE: 'comfortable',
  COMPACT: 'compact',
  DEFAULT: 'default',
};

/** spacing styles */
export const SPACING = {
  [SPACING_NAMES.COMFORTABLE]: '56px',
  [SPACING_NAMES.COMPACT]: '40px',
  [SPACING_NAMES.DEFAULT]: '48px',
};
